import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "BaseAttachments" }
const _hoisted_2 = { class: "row items-center gap-12" }

import type { QFile } from 'quasar'
import { IAttachment } from 'src/common/interfaces'
import useNotify from 'src/hook/useNotify'
import { ref } from 'vue'
import globalTranslateObject from 'src/translate/global.translate'
import translate from 'src/common/helpers/language/translate'

interface IEmits {
  (event: 'delete', data: IAttachment): void
}

interface IProps {
  externalLabel?: string
  externalLabelDescription?: string
  externalLabelCalloutTitle?: string
  externalLabelCalloutDescription?: string
}

const maxFileSize = 2000000 // 2MB


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseAttachments',
  props: /*@__PURE__*/_mergeModels({
    externalLabel: { default: '' },
    externalLabelDescription: { default: '' },
    externalLabelCalloutTitle: { default: '' },
    externalLabelCalloutDescription: { default: '' }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
    "file": { required: true, default: () => ({}) },
    "fileModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["delete"], ["update:modelValue", "update:file"]),
  setup(__props: any, { emit: __emit }) {



const emit = __emit
const model = _useModel<IAttachment[]>(__props, "modelValue")
const fileModel = _useModel<File>(__props, 'file')

const { t: globalT } = translate(globalTranslateObject)
const { notify } = useNotify()

const fileRef = ref<QFile | null>(null)

function handleFileSelection($event: File) {
  if ($event?.size > maxFileSize) {
    notify(false, globalT('errors.max_file_size', ['2MB']))
    return
  }

  if (Object.keys($event).length) {
    model.value.push({ file: $event, preview: URL.createObjectURL($event) })
    fileModel.value = {} as File
  }
}

function handleFileDelete(index: number) {
  emit('delete', model.value[index])
  model.value.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_k_external_label = _resolveComponent("k-external-label")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_BaseFormAttachment = _resolveComponent("BaseFormAttachment")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      (__props.externalLabel)
        ? (_openBlock(), _createBlock(_component_k_external_label, {
            key: 0,
            description: __props.externalLabelDescription,
            for: _ctx.$attrs['for'],
            label: __props.externalLabel,
            required: _ctx.$attrs['is-required'],
            "callout-title": __props.externalLabelCalloutTitle,
            "callout-description": __props.externalLabelCalloutDescription
          }, null, 8 /* PROPS */, ["description", "for", "label", "required", "callout-title", "callout-description"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_file, {
        ref_key: "fileRef",
        ref: fileRef,
        modelValue: fileModel.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((fileModel).value = $event)),
          handleFileSelection
        ],
        accept: "image/jpeg, image/jpg, image/webp, image/png, image/bmp",
        class: "hidden"
      }, null, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_component_BaseFormAttachment, {
        "is-input": true,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (fileRef.value?.pickFiles()))
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value, (attachment, index) => {
        return (_openBlock(), _createBlock(_component_BaseFormAttachment, {
          key: index,
          src: attachment.preview,
          onClickCapture: ($event: any) => (handleFileDelete(index))
        }, null, 8 /* PROPS */, ["src", "onClickCapture"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})